<template>
	<div id="forget">
		<div class="box">
			<p class="tip">{{$t("forget_title")}}</p>
			<el-form id="forgetForm" ref="forgetForm" :model="forgetForm" :rules="registRule">
				<el-form-item v-if="language=='zh'" class="input" prop="mobile" style="margin-top: .2rem">
					<el-input v-model="forgetForm.mobile" :placeholder="$i18n.t('register_mobile_input')">
						<i slot="prefix" class="iconfont iconshoujix" style="margin-left: 0.05rem"></i>
					</el-input>
				</el-form-item>
				<el-form-item v-else class="input" prop="email" style="margin-top: .2rem">
					<el-input v-model="forgetForm.email" :placeholder="$i18n.t('register_email_input')">
						<i slot="prefix" class="iconfont iconxiaoxix" style="margin-left: 0.05rem"></i>
					</el-input>
				</el-form-item>
				<el-form-item class="input" prop="smsCode">
					<el-col :span="12">
						<el-input v-model="forgetForm.smsCode" :placeholder="$i18n.t('register_sms_input')">
							<i slot="prefix" class="iconfont iconyanzhengmax" style="margin-left: 0.05rem"></i>
						</el-input>
					</el-col>
					<el-col :span="1">&nbsp;</el-col>
					<el-col :span="11">
					  <el-popover placement="left-end" width="230" v-model="dialogVcode" popper-class="registerHover">
					    <el-form id="dialogVcode" ref="dialogVcode">
					      <el-form-item class="input" prop="vcode" style="margin-bottom:0;">
					        <img class="vcodeImage" :src="vcodeurl" @click="flashcode()" />
					        <el-input style="width:50%" class="vcodeInput" size="large" v-model="forgetForm.vcode" :placeholder="$i18n.t('buchong').tips_count_result" />
					      </el-form-item>
					      <el-button style="float:right;margin-top:0.1rem;margin-right:0.1rem;background-color:#57AEC9;border-color:#57AEC9;" class="btn1" type="primary" @click="prevsms()">{{$t("buchong").sure}}</el-button>
					    </el-form>
					    <el-button slot="reference" type="primary" :style="'min-width: 95px;background-color:'+bgcolor" :disabled="isSmsEnabled">{{smsBtnText}}</el-button>
					  </el-popover>
					</el-col>
				</el-form-item>
				<el-form-item class="input" prop="password">
					<el-input v-model="forgetForm.password" type="password" :placeholder="$i18n.t('login_pass_input')">
						<i slot="prefix" class="iconfont iconmimax" style="margin-left: 0.05rem"></i>
					</el-input>
				</el-form-item>
				<el-form-item class="input" prop="confirm_pwd">
					<el-input v-model="forgetForm.confirm_pwd" type="password" :placeholder="$i18n.t('forget_pass_input_re')">
						<i slot="prefix" class="iconfont iconmimax" style="margin-left: 0.05rem"></i>
					</el-input>
				</el-form-item>
				<el-button class="btn1" type="primary" @click="submit">{{$t("normal_sure")}}</el-button>
				<p class="register font14 login" @click="login">{{$t("forget_fast_login")}}</p>
				<p class="register font14" @click="register">{{$t("register_title")}}</p>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'forget',
		data: function() {
			let confirmPass = (rule, value, callback) => {
				if (value === null) {
					callback(new Error(this.$i18n.t('normal_notnull')))
				} else if (value !== this.forgetForm.confirm_pwd) {
					callback(new Error(this.$i18n.t('register_repassword')))
				} else {
					callback()
				}
			}
			return {
				forgetForm: {
					email: null,
					mobile: null,
					password: null,
					smsCode: null,
					confirm_pwd: null,
					vcode: null
				},
				visible2: false,
				registRule: {},
				counter: 0,
				smsBtnText: '',
				timer: null,
				vcodemobile: 1,
				randi: 1,
				bgcolor: '#ababab;border:none;',
				dialogVcode: false,
				r: '',
				t: '',
				vcodeurl: '',
				language: '',
				confirmPass: confirmPass
			}
		},
		computed: {
			isSmsEnabled () {
			  if(this.language == 'zh'){
				if (this.forgetForm.mobile == null || this.forgetForm.mobile === '' || this.forgetForm.mobile.length !== 11 || this.timer !== null) {
				  this.bgcolor = '#ababab;border:none;'
				  return true
				}
			  }else{
				if (this.forgetForm.email == null || this.forgetForm.email === '' || this.timer !== null) {
				  this.bgcolor = '#ababab;border:none;'
				  return true
				}
			  }
			  this.bgcolor = '#57AEC9;'
			  return false
			}
		},
		watch: {
			counter: function(val) {
				if (val > 0) {
					this.smsBtnText = '(' + val + ')' + this.$i18n.t('register_get_smscode_re')
				} else {
					this.smsBtnText = this.$i18n.t('register_get_smscode')
					if (this.timer) {
						clearInterval(this.timer)
						this.timer = null
					}
				}
			}
		},
		mounted() {
			this.language = localStorage.locale;
			this.smsBtnText = this.$i18n.t('register_get_smscode')
			if(this.language == 'zh'){
				this.registRule.mobile = [{
					required: true,
					message: this.$i18n.t('normal_notnull'),
					trigger: 'blur'
				}]
			}else{
				this.registRule.email = [{
					required: true,
					message: this.$i18n.t('normal_notnull'),
					trigger: 'blur'
				}]
			}
			this.registRule.password = [{
				required: true,
				message: this.$i18n.t('normal_notnull'),
				trigger: 'blur'
			}]
			this.registRule.smsCode = [{
				required: true,
				message: this.$i18n.t('normal_notnull'),
				trigger: 'submit'
			}]
			this.registRule.confirm_pwd = [{
				validator: this.confirmPass,
				trigger: 'blur'
			}]
			
			this.flashcode();
		},
		methods: {
			flashcode() {
				this.t = new Date().getTime();
				this.r = Math.random();
				this.vcodeurl = "/sms/setVcodeImage?t=" + this.t + "&r=" + this.r;
			},
			prevsms() {
			  let _this = this;
			  let sure = this.$i18n.t('normal_sure')
			  let normal_tips = this.$i18n.t('normal_tips')
			  let count_not_right = this.$i18n.t('count_not_right')
			  let normal_networkerror = this.$i18n.t('normal_networkerror')
			  this.axios({
			    method: "post",
			    url: "/sms/checkVcode",
			    data: { t: this.t, r: this.r, vcode: this.forgetForm.vcode }
			  })
			    .then(function(res) {
			      console.log(res);
			      if (res.data.code == 0) {
			        _this.dialogVcode = false;
			        _this.sendSms();
			      } else {
			        _this.$alert(count_not_right, normal_tips, {
			          confirmButtonText: sure
			        });
			        _this.flashcode();
			      }
			    })
			    .catch(function(err) {
			      if (err.msg) {
			        _this.$alert(err.msg , normal_tips, { confirmButtonText: sure });
			      } else {
			        _this.$alert(normal_networkerror, normal_tips, {
			          confirmButtonText: sure
			        });
			        _this.flashcode();
			      }
			    });
			},
			login() {
				this.$router.replace('/login')
			},
			register() {
				this.$router.replace('/register')
			},
			sendSms () {
			  if (this.counter > 0) {
			    return
			  }
			  if(this.language == 'zh'){
				if (this.forgetForm.mobile == null || this.forgetForm.mobile === '' || this.forgetForm.mobile.length !== 11) {
				  this.$message(this.$i18n.t('register_mobile_notright'))
				  return false
				}
				this.visible2 = false
				send(this)
				function send (self) {
				  let post = {
				    vcode: self.forgetForm.vcode,
					mobile: self.forgetForm.mobile,
				    biz: 1001,
				    src: 10,
				    r: self.r,
				    t: self.t
				  }
				  self.axios({
				    method: 'post',
				    url: '/sms/send',
				    data: post
				  }).then((response) => {
				    let data = response.data
				    if (data.code === 0) {
				      self.counter = 60
				      self.timer = setInterval(() => {
				        self.counter = self.counter - 1
				      }, 1000)
				    } else {
				      console.log(data.msg)
				      self.$message({
				        message: data.msg,
				        type: 'warning'
				      })
				    }
				  }).catch(function (err) {
				    console.log(err)
				  })
				}
			  }else{
				let myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
				if (
				  this.forgetForm.email === "" ||
				  this.forgetForm.email == null ||
				  !myreg.test(this.forgetForm.email)
				) {
				  this.$message(this.$i18n.t('register_email_notright'))
				  return
				}
				this.visible2 = false
				sendEmail(this)
				function sendEmail(self){
					let post = {
					  vcode: self.forgetForm.vcode,
					  email: self.forgetForm.email,
					  biz: 1001,
					  src: 10,
					  r: self.r,
					  t: self.t
					}
					self.axios({
					  method: 'post',
					  url: '/email/send',
					  data: post
					}).then((response) => {
					  let data = response.data
					  if (data.code === 0) {
					    self.counter = 60
					    self.timer = setInterval(() => {
					      self.counter = self.counter - 1
					    }, 1000)
					  } else {
					    console.log(data.msg)
					    self.$message({
					      message: data.msg,
					      type: 'warning'
					    })
					  }
					}).catch(function (err) {
					  console.log(err)
					})
				}
			  }
			},
			submit() {
				this.is_send = false
				this.is_submit = true
				this.$refs['forgetForm'].validate((valid) => {
					if (valid) {
						this.confirmResetPassword()
					} else {
						console.log('error!')
						return false
					}
				})
			},
			confirmResetPassword() {
				let post = {
					app_type: 'zmskin',
					password: this.forgetForm.password,
					smsCode: this.forgetForm.smsCode
				}
				if(this.language == 'zh'){
					post.mobile = this.forgetForm.mobile
				}else{
					post.email = this.forgetForm.email
				}
				let formData = this.formData(post)
				let _this = this
				this.axios({
						method: 'post',
						url: '/userSrv/user/resetPwd',
						data: formData
					})
					.then(function(res) {
						console.log(res)
						if (res.data.code === 0) {
							_this.$message(_this.$i18n.t('forget_reset_success'))
							_this.$router.replace('/login')
						} else {
							_this.$message(res.data.msg)
						}
					})
					.catch(function(err) {
						console.log(err)
					})
			}
		}
	}
</script>

<style lang="scss">
	#forget {
		.el-input__inner {
			height: 0.4167rem;
			border: none;
			border-bottom: 1px solid #ccc;
			border-radius: 0;
			font-size: 0.12rem;
		}

		.el-form-item__content {
			line-height: 0.4167rem;
		}
	}
</style>

<style scoped lang="scss">
	#forget {
		display: inline-block;
		height: 100%;
		width: 20.8vw;
		position: relative;
		z-index: 10;
		float: right;
		margin-right: 16.6vw;

		.box {
			position: absolute;
			width: 20.8vw;
			height: 4.8rem;
			background-color: #fff;
			border-radius: .05rem;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			margin: auto;

			.tip {
				margin-top: .6rem;
				font-size: 0.25rem;
				color: #57AEC9;
				text-align: center;
			}

			.input {
				width: 15.6vw;
				height: 0.4167rem;
				margin: 0.1667rem auto 0;
				color: #bfbfbf;

				input {
					display: inline-block;
					vertical-align: top;
					width: 3.02rem;
					height: .5rem;
					font-size: .18rem;
					border-bottom: 1px solid #ccc;
				}
			}

			.input::-webkit-input-placeholder,
			.input:-moz-placeholder,
			.input:-ms-input-placeholder {
				color: #bfbfbf;
			}

			.input1 {
				margin: .63rem auto 0;
			}

			.yanzhengma {
				margin: .3rem .1rem 0 .58rem;
				display: inline-block;
				width: 2.5rem;

				input {
					width: 1.9rem;
				}
			}

			.forget {
				color: #666666;
				float: right;
				margin: .1rem .53rem 0 0;
				font-size: .12rem;
			}

			.btn1 {
				width: 15.6vw;
				height: 0.416rem;
				margin: 0.25rem 2.6vw 0.167rem;
				color: #fff;
				text-align: center;
				font-size: 0.167rem;
				background-color: #57AEC9;
				border: none;
			}

			.btnsms {
				width: calc(100% - 5px);
				background-color: #fff;
				border-color: #57AEC9;
				color: #57AEC9;
				margin: 0;
				float: right;
			}

			.register {
				display: inline-block;
				color: #666666;
				text-align: left;
				font-size: .12rem;
				cursor: pointer;
				width: auto;
				float: right;
				margin-right: 2.6vw;
			}

			.login {
				float: left;
				margin-left: 2.6vw;
			}

			.login:hover,
			.register:hover {
				text-decoration: none;
				color: #333;
			}

			.register i {
				margin-left: .1rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/forget.vue